import PropTypes from 'prop-types';
import React from 'react';
import MediaQuery from 'react-responsive';
import { FormattedMessage } from 'react-intl';

export class TableRow extends React.Component {
  constructor(props) {
    super(props);
    this.handleDataRowClick = this.handleDataRowClick.bind(this);

    this.state = { expanded: false };
  }

  componentWillReceiveProps() {
    if (this.props.customExpansion) {
      this.setState({ expanded: false });
    }
  }

  /* Indicates width breakpoint when at least one column is collapsed */
  getCollapsedWidth = () => {
    let width = 0;
    this.props.columns.forEach((column) => {
      if (width < column.maxCollapsedWidth) {
        width = column.maxCollapsedWidth;
      }
    });
    return width;
  }

  handleDataRowClick() {
    this.setState({ expanded: !this.state.expanded }); 
    if (this.props.rowClicked){
      this.props.rowClicked();
    }
  }

  renderCell(column, data) {
    const fieldValue = data[column.dataField];

    if (column.renderField) {
      return column.renderField(fieldValue, data);
    }
    return fieldValue;
  }

  renderDataRow() {
    return (
      <tr className={this.props.className} 
        onClick={this.props.rowClicked}
      >
        {this.props.columns.map((column, colIndex) => (
          <td className={column.hidden ? 'hidden' : column.dataCellCss } key={colIndex}>
            { this.renderCell(column, this.props.data) }
          </td>
        ))}
      </tr>
    );
  }

  renderCustomExpansionRowContent() {
    const expansionColumn = this.props.columns.find(col => col.customExpansion);
    if (!expansionColumn) {
      return null;
    }
    return (
      <tr className={this.state.expanded ? 'table-expand-area' : 'hidden'} >
        <td colSpan="100%" className={ expansionColumn.dataCellCss } >
          { this.renderCell(expansionColumn, this.props.data) }
        </td>
      </tr>
    );
  }


  renderCollapsedDataRow() {
    return (
      <tr className={'collapsible ' + this.props.className } onClick={this.handleDataRowClick}>
        <MediaQuery maxWidth={this.getCollapsedWidth()}>
          <td>
            <span className={this.state.expanded ?
              'fa-solid fa-chevron-down' : 
              'fa-solid fa-chevron-right'
            }/>
          </td>
        </MediaQuery>

        {this.props.columns.map((column, colIndex) => (
          <MediaQuery key={colIndex} minWidth={column.maxCollapsedWidth ? column.maxCollapsedWidth : 0}>
            <td className={column.hidden ? 'hidden' : column.dataCellCss} key={colIndex}>
              { this.renderCell(column, this.props.data) }
            </td>
          </MediaQuery>
        ))}
      </tr>
    );
  }

  renderCollapsedRowContent() {
    return (
      <tr className={this.state.expanded ? 'table-expand-area' : 'hidden'}>
        <td colSpan="100%">
          <table className="table no-background">
            <tbody>
              {
                this.props.columns.map((column, colIndex) => {
                  if (column.maxCollapsedWidth) {
                    return (
                      <MediaQuery maxWidth={column.maxCollapsedWidth} key={colIndex}>
                        <tr>
                          <td className="mobile-table-data-label">
                            <FormattedMessage {...column.name} />:
                          </td>
                          <td className={'mobile-table-data ' + this.props.className}>
                            { this.renderCell(column, this.props.data) }
                          </td>
                        </tr>
                      </MediaQuery>
                    );
                  }
                  return null;
                })
              }
            </tbody>
          </table>
        </td>
      </tr>
    );
  }
  render() {
    const columnsCollapsedWidth = this.getCollapsedWidth();
    if (this.props.customExpansion) {
      return (
        <tbody>
          <MediaQuery maxWidth={columnsCollapsedWidth}>
            {this.renderCollapsedDataRow()}
          </MediaQuery>
          <MediaQuery maxWidth={columnsCollapsedWidth}>
            {this.renderCustomExpansionRowContent()}
          </MediaQuery>
        </tbody>
      );
    }
    return (
      <tbody>
        <MediaQuery maxWidth={columnsCollapsedWidth}>
          {this.renderCollapsedDataRow()}
        </MediaQuery>
        <MediaQuery maxWidth={columnsCollapsedWidth}>
          {this.renderCollapsedRowContent()}
        </MediaQuery>
        <MediaQuery minWidth={columnsCollapsedWidth + 1}>
          {this.renderDataRow()}
        </MediaQuery>
      </tbody>
    );
  }
}

TableRow.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  className: PropTypes.string,
  customExpansion: PropTypes.bool,
  rowClicked: PropTypes.func,
};
